/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_TICKET_QUERY,
  LOAD_TICKET_QUERY_SUCCESS,
  LOAD_TICKET_QUERY_ERROR,

  ADD_TICKET_QUERY,
  ADD_TICKET_QUERY_SUCCESS,
  ADD_TICKET_QUERY_ERROR,

  UPDATE_TICKET_QUERY,
  UPDATE_TICKET_QUERY_SUCCESS,
  UPDATE_TICKET_QUERY_ERROR,
  DELETE_TICKET_QUERY,
  DELETE_TICKET_QUERY_SUCCESS,
  DELETE_TICKET_QUERY_ERROR,

  LOAD_ACTIVITY,
  LOAD_ACTIVITY_SUCCESS,
  LOAD_ACTIVITY_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//permission list
export function loadTicketQuery(searchvalue) {
  return {
    type: LOAD_TICKET_QUERY,
    searchvalue,
  }
}
export function loadTicketQuerySuccess(ticket_details) {
  return {
    type: LOAD_TICKET_QUERY_SUCCESS,
    ticket_details,
  }
}
export function loadTicketQueryError(error) {
  return {
    type: LOAD_TICKET_QUERY_ERROR,
    error,
  }
}

//add clearance

export function addQueryChat(queryChat) {
  return {
    type: ADD_TICKET_QUERY,
    queryChat,
  }
}
export function addQueryChatSuccess(queryChat, success) {
  return {
    type: ADD_TICKET_QUERY_SUCCESS,
    queryChat,
    success
  }
}
export function addQueryChatError(error) {
  return {
    TYPE: ADD_TICKET_QUERY_ERROR,
    error,
  }
}
//Update Unassigned Details

export function updateTicketClose(ticketClose) {
  return {
    type: UPDATE_TICKET_QUERY,
    ticketClose,
  }
}
export function updateTicketCloseSuccess(ticketClose, success) {
  return {
    type: UPDATE_TICKET_QUERY_SUCCESS,
    ticketClose,
    success
  }
}
export function updateTicketCloseError(error) {
  return {
    TYPE: UPDATE_TICKET_QUERY_ERROR,
    error,
  }
}
//Update Unassigned Details

export function deleteTicketQuery(deleteTicket) {
  return {
    type: DELETE_TICKET_QUERY,
    deleteTicket,
  }
}
export function deleteTicketQuerySuccess(deleteTicket, success) {
  return {
    type: DELETE_TICKET_QUERY_SUCCESS,
    deleteTicket,
    success
  }
}
export function deleteTicketQueryError(error) {
  return {
    TYPE: DELETE_TICKET_QUERY_ERROR,
    error,
  }
}

//loadActivity
export function loadActivity(activityDetails) {
  return {
    type: LOAD_ACTIVITY,
    activityDetails,
  }
}
export function loadActivitySuccess(activities_data) {
  return {
    type: LOAD_ACTIVITY_SUCCESS,
    activities_data,
  }
}
export function loadActivityError(error) {
  return {
    type: LOAD_ACTIVITY_ERROR,
    error,
  }
}
const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadTicketQuery,
  loadTicketQuerySuccess,
  loadTicketQueryError,

  addQueryChat,
  addQueryChatSuccess,
  addQueryChatError,

  updateTicketClose, 
  updateTicketCloseSuccess, 
  updateTicketCloseError, 

  deleteTicketQuery, 
  deleteTicketQuerySuccess, 
  deleteTicketQueryError, 
}

export default actions
